import React, { useEffect, useState } from 'react';
import { Card, Table, Space, Input, Button, Tag, Select, message, Popconfirm } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { visitorService } from '../services/visitor';

interface IPListItem {
  id: number;
  type: 'whitelist' | 'blacklist';
  ip: string;
  note?: string;
  link_id?: number;
  created_at: string;
}

const IPList: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState<IPListItem[]>([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [type, setType] = useState<'whitelist' | 'blacklist' | undefined>();
  const [ip, setIP] = useState('');
  const [note, setNote] = useState('');

  const loadData = async (p = page, s = size) => {
    setLoading(true);
    try {
      const data = await visitorService.listIPList({ type, page: p, size: s });
      setList(data.list || []);
      setTotal(data.total || 0);
      setPage(data.page || p);
      setSize(data.size || s);
    } catch (e: any) {
      message.error(e?.message || '加载失败');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadData(1, size); // 初始化
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type]);

  const handleAdd = async () => {
    if (!ip) { message.warning('请输入IP或CIDR'); return; }
    if (!type) { message.warning('请选择名单类型'); return; }
    try {
      await visitorService.addIPToList({ ip, type });
      setIP(''); setNote('');
      message.success('已添加');
      loadData(1, size);
    } catch (e: any) {
      message.error(e?.message || '添加失败');
    }
  };

  const handleDelete = async (id: number) => {
    try {
      await visitorService.deleteIPFromList(id);
      message.success('已删除');
      loadData(page, size);
    } catch (e: any) {
      message.error(e?.message || '删除失败');
    }
  };

  const columns: ColumnsType<IPListItem> = [
    { title: '类型', dataIndex: 'type', key: 'type', render: (t) => <Tag color={t === 'whitelist' ? 'green' : 'red'}>{t === 'whitelist' ? '白名单' : '黑名单'}</Tag> },
    { title: 'IP / CIDR', dataIndex: 'ip', key: 'ip' },
    { title: '备注', dataIndex: 'note', key: 'note' },
    { title: '创建时间', dataIndex: 'created_at', key: 'created_at' },
    {
      title: '操作', key: 'action', render: (_, r) => (
        <Space>
          <Popconfirm title="确认删除该条目?" onConfirm={() => handleDelete(r.id)}>
            <Button danger>删除</Button>
          </Popconfirm>
        </Space>
      )
    }
  ];

  return (
    <Card title="IP黑白名单" extra={
      <Space>
        <Select placeholder="选择类型" style={{ width: 140 }} value={type} allowClear onChange={v => setType(v)}
          options={[{ value: 'whitelist', label: '白名单' }, { value: 'blacklist', label: '黑名单' }]} />
        <Input placeholder="输入IP或CIDR" value={ip} onChange={(e) => setIP(e.target.value)} style={{ width: 220 }} />
        <Input placeholder="备注(可选)" value={note} onChange={(e) => setNote(e.target.value)} style={{ width: 220 }} />
        <Button type="primary" onClick={handleAdd}>添加</Button>
      </Space>
    }>
      <Table
        rowKey={(r) => String(r.id)}
        loading={loading}
        columns={columns}
        dataSource={list}
        pagination={{ current: page, pageSize: size, total, onChange: (p, s) => loadData(p, s) }}
      />
    </Card>
  );
};

export default IPList;


